module.exports = __webpack_public_path__ + "static/media/uxaudit.b6f851d0.png";